import './i18n';
import './App.css';
import SetupRouter from './routes/SetupRouter';
function App() { return <SetupRouter />; }
export default App;
